import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15;

export default {
    services: {
        /**
         * Create a new reservation.
         * @param {Object} reservation - Reservation payload.
         * @param {string} [token] - Optional authentication token.
         * @returns {Promise} Axios promise resolving to created reservation.
         */
        createReservation: (payload, token = "") => {
            return axios(token).post(`/reservations`, payload)
        },
        getReservations: (limit = 15, page = 1, query = "", token = "") => {
            return axios(token).get(`/reservations?limit=${limit}&page=${page}${query ? `&${query}` : ""}`)
        },
        /**
         * Retrieves metadata for reservations filtering with optional query parameters
         * @param {string} [query=""] - Query string for filtering metadata
         * @param {string} token - Authentication token
         * @returns {Promise<ApiResponse>} Promise that resolves to reservation metadata
         */
        getMetadataReservations: (query = "", token) => {
            return axios(token).get(`/reservations/status/counts${query ? `?${query}` : ""}`)
        },

        /**
         * Confirm a reservation by id.
         * @param {string} id - Reservation identifier.
         * @param {Object} [payload={}] - Optional payload for confirmation.
         * @param {string} [token=""] - Optional authentication token.
         * @returns {Promise} Axios promise resolving to confirmation result.
         */
        confirmReservationById: (id, payload = {}, token = "") => {
            return axios(token).post(`/reservations/${id}/confirm`, payload);
        },
        /**
         * Get a single reservation by id.
         * @param {string} reservationId - Reservation identifier.
         * @param {boolean} [populate=true] - Whether to populate referenced fields.
         * @param {string} [token=""] - Optional authentication token.
         * @returns {Promise} Axios promise resolving to reservation data.
         */
        getReservation: (id, populate = true, token = "") => {
            return axios(token).get(`/reservations/${id}?populate=${populate}`)
        },
        updateReservation: (reservationId, reservation, recipients, reason, token) => {
            return axios(token).put(`/reservations/${reservationId}`, { reservation: reservation, recipients: recipients, reason: reason })
        },
        deleteReservation: (reservationId, token = "") => {
            return axios(token).delete(`/reservations/${reservationId}`)
        },
        deleteReservationMany: (reservations, token = "") => {
            return axios(token).put(`/deleteMany/reservations`, { reservations: reservations })
        },
        updateStatusReservation: (reservationId, payload, responsible, role, token = "") => {
            if (responsible) {
                return axios(token).put(`/reservations/status/changue/${reservationId}`, payload, { headers: { "responsible": responsible, "role": role } })
            } else {
                return axios(token).put(`/reservations/status/changue/${reservationId}`, payload)
            }
        },
        /**
         * Reject a reservation by id.
         * @param {string} id - Reservation identifier.
         * @param {Object} payload - Payload containing rejection details.
         * @param {string} [token=""] - Optional authentication token.
         * @returns {Promise} Axios promise resolving to rejection result.
         */
        rejectReservationById: (id, payload, token = "") => {
            return axios(token).post(`/reservations/${id}/reject`, payload);
        },
        /**
         * Cancel a reservation by id.
         * @param {string} reservationId - Reservation identifier.
         * @param {string} reason - Reason for cancellation.
         * @param {string} [token=""] - Optional authentication token.
         * @returns {Promise} Axios promise resolving to cancellation result.
         */
        cancelReservationById: (id, reason, token = "") => {
            return axios(token).post(`/reservations/${id}/cancel`, { reason: reason })
        },
        /***
         * 
         * History service
         * 
         * ***/
        getHistoriesByReservationId: (reservationId, limit, page, token) => {
            return axios(token).get(`/modules/reservations/${reservationId}/histories?limit=${limit}&page=${page}`)
        },
        updateHistoryById: (historyId, history, token = "") => {
            return axios(token).put(`/histories/${historyId}`, history)
        },
        changeRservationStatus: (reservationId, status, reason, token = "") => {
            return axios(token).patch(`/reservations/${reservationId}/updateAnyStatus`, { status: status, reason: reason })
        },
        resendEmailToUsersByReservationId(reservationId, payload, token = "") {
            return axios(token).post(`/reservations/${reservationId}/resend-email`, payload)
        },
        createPartialDriverProfile: (branchId, driver, token = "") => {
            return axios(token).post(`/branches/${branchId}/drivers`, driver);
        },
        getDriversByBranchId: (branchId, token = "") => {
            return axios(token).get(`/branches/${branchId}/drivers-options`);
        },
        /**
         * Assign a driver to a reservation.
         * @param {string} reservationId - Reservation identifier.
         * @param {Object} payload - Driver assignment payload (e.g. driverId, vehicle info).
         * @param {string} [token=""] - Optional authentication token.
         * @returns {Promise} Axios promise resolving to the updated reservation.
         */
        assignDriverByReservationId: (id, payload, token = "") => {
            return axios(token).post(`/reservations/${id}/assign-driver`, payload)
        },
        downloadPDF: (pdfType, identifire, client, voucherType, token = '') => {
            return axios(token).get(`/reservations/${identifire}/generate-pdf?pdfType=${pdfType}&userType=${client.type}&userReference=${client._id}&voucherType=${voucherType}`, {
                responseType: 'blob',
            });
        }
    }
}